// @flow

export const fetchServiceProvider = async (selfUrl: Url): Promise<ServiceProvider> => {
  const response = await fetch(selfUrl, {
    headers: {
      'content-type': 'application/json; version=2.0',
      'Accept': 'application/json; version=2.0',
    },
  })
  if (response.status === 200) {
    return await response.json()
  } else {
    throw new Error(await response.text())
  }
}